import { render, staticRenderFns } from "./DonationList.vue?vue&type=template&id=0268d1fa&scoped=true&"
import script from "./DonationList.vue?vue&type=script&lang=js&"
export * from "./DonationList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./DonationList.vue?vue&type=style&index=0&id=0268d1fa&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0268d1fa",
  "15645523"
  
)

export default component.exports